module.exports = __webpack_public_path__ + "static/media/button.71aac6ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameShipPainting/button.png
// module id = 937
// module chunks = 0